import { Component, EventEmitter, Input, Output } from '@angular/core';

interface ISampleColumn {
    letter: string;
    header: string;
    /** Only the two columns the import reads are highlighted — as one block, so it has two edges. */
    read: boolean;
    edge?: 'start' | 'end';
    calloutKey?: string;
}

/**
 * Shows what a rate list for the import looks like: a sample of the Kendris export with the two
 * columns the import reads highlighted, and how the closing and average rates come out of it.
 */
@Component({
    selector: 'aumico-fx-rate-file-guide',
    templateUrl: './fx-rate-file-guide.component.html',
    styleUrls: ['./fx-rate-file-guide.component.scss'],
})
export class FxRateFileGuideComponent {
    @Input() functionalCurrencyName = '';
    @Input() displayCurrencyName = '';
    @Output() closed = new EventEmitter<void>();

    readonly columns: ISampleColumn[] = [
        { letter: 'A', header: 'Base Currency', read: false },
        { letter: 'B', header: 'Currency', read: false },
        { letter: 'C', header: 'Client', read: false },
        { letter: 'D', header: 'Deposit', read: false },
        {
            letter: 'E',
            header: 'Date',
            read: true,
            edge: 'start',
            calloutKey: 'aumico_annual_report_fx_rates_guide_callout_date',
        },
        {
            letter: 'F',
            header: 'Actual Rate',
            read: true,
            edge: 'end',
            calloutKey: 'aumico_annual_report_fx_rates_guide_callout_rate',
        },
        { letter: 'G', header: 'Original Rate', read: false },
        { letter: 'H', header: 'Lombard Rate', read: false },
        { letter: 'I', header: 'Import data', read: false },
    ];

    readonly sampleRows: { date: string; rate: string; importId: string }[] = [
        { date: '29.12.2025', rate: '0.79270', importId: '69959' },
        { date: '30.12.2025', rate: '0.79310', importId: '69964' },
        { date: '31.12.2025', rate: '0.79640', importId: '69974' },
    ];

    /** The sample cell of a column — the report's own currencies, so the example reads true. */
    cellOf(row: { date: string; rate: string; importId: string }, column: ISampleColumn): string {
        switch (column.header) {
            case 'Base Currency':
                return this.displayCurrencyName;
            case 'Currency':
                return this.functionalCurrencyName;
            case 'Date':
                return row.date;
            case 'Actual Rate':
            case 'Original Rate':
                return row.rate;
            case 'Import data':
                return row.importId;
            default:
                return '';
        }
    }
}
